import React, { useEffect } from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";

export const CustomSelect = (props) => {
  const {
    label,
    value,
    setValue,
    data,
    isError,
    errorMsg,
    className,
    disabled = false,
    extraLabel = "",
    requiredField,
    withDefaultValue = false,
    setChanged,
    name = "",
    containerStyle = {},
    displayField = "name",
    onChangeEvent = () => {},
  } = props;
  const labelField = requiredField ? `${label}*` : label;

  useEffect(() => {
    if (withDefaultValue) {
      if (data?.length) {
        setValue(data[0]);
      } else {
        setValue({ id: 0, name: "No hay opciones" });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, withDefaultValue]);

  const renderHelperText = () => {
    if (isError) {
      return <FormHelperText>{errorMsg}</FormHelperText>;
    } else if (extraLabel) {
      return <FormHelperText>{extraLabel}</FormHelperText>;
    }
  };

  const onChange = (e) => {
    setValue(e.target.value);
    if (setChanged) {
      setChanged(true);
    }
    onChangeEvent(e);
  };

  return (
    <FormControl error={isError} className={className} style={containerStyle}>
      <InputLabel>{labelField}</InputLabel>
      <Select
        name={name}
        value={value}
        onChange={onChange}
        error={isError}
        renderValue={(v) => v?.[displayField] || ""}
        defaultValue={null}
        disabled={disabled}
      >
        {data.map((item, index) => (
          <MenuItem key={index} value={item || {}}>
            {item?.[displayField] || ""}
          </MenuItem>
        ))}
      </Select>
      {renderHelperText()}
    </FormControl>
  );
};
